import React from "react";
import PropTypes from "prop-types";
import loc from "../Assets/Images/loc.png";
import { formatAmount } from "../utils/formatAmount";

const RealEstateOpportunities = ({
  imageSrc,
  location,
  title,
  price,
  onClick,
  investedPercentage,
  totalAmount,
  currency,
  status,
}) => {
  return (
    <div
      onClick={onClick}
      className="cursor-pointer shadow-lg rounded-[12px] p-4 relative overflow-hidden w-[344px] h-[440px]"
    >
      <div className="relative mb-[30px] w-full ">
        <img
          src={imageSrc}
          alt="Investment Banner"
          className="w-full h-[260px] rounded-[12px] object-cover"
        />
        <div className="absolute bottom-0 left-0 mb-[15px] ml-[15px] w-[180px] h-[27px] rounded-[30px] bg-[#2C2C2C66] flex items-center px-3">
          <img src={loc} alt="Location" className="w-[16px] h-[16px] mr-2" />
          <h4 className="font-[400] text-[14px] text-[#FFF]">{location}</h4>
        </div>
      </div>
      <div className="flex flex-col h-[120px]  justify-between">
        <div>
          <h4 className=" tracking-[-1%] font-[500] text-[16px] text-[#131E3D]">
            {title}
          </h4>
          <div className="font-[400] text-[14px] text-[#131E3D]">
            {currency === "USD" ? "$" : "₦"}
            {formatAmount(price)} per unit
          </div>
          {status == 9 ? (
            <></>
          ) : (
            <>
              <div className="mt-[12px] font-[400] text-[14px] text-[#9c9c9e]">
                {investedPercentage}% invested of{" "}
                {currency === "USD" ? "$" : "₦"}
                {formatAmount(totalAmount)}
              </div>
              <div className="w-full mt-[10px] overflow-hidden bg-[#F2F2F7] rounded-full h-[4px]">
                <div
                  className="bg-[#6935D3] h-[4px] rounded-full"
                  style={{ width: `${investedPercentage}%` }}
                ></div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

RealEstateOpportunities.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  investedPercentage: PropTypes.number.isRequired,
  totalAmount: PropTypes.number.isRequired,
};

export default RealEstateOpportunities;
